import { useSelector } from "react-redux";
import { getCanonicalTimezone, getTradingViewTimezone } from "@helpers/timezone";

export const useProfileUserData = () => {
  const user = useSelector(
    (state) => state.user.user || {},
  );

  const locale = useSelector(
    (state) => state.localization.locale,
  );

  const {
    nickname,
    first_name,
    last_name,
    email,
    date_birth,
    country,
    phone,
    timezone: reduxTimezone,
    ondato_status,
    is_user_verified,
    kyc_submission,
    id,
    display_id,
    avatar_url,
  } = user;

  const browserTimezone =
    Intl.DateTimeFormat().resolvedOptions().timeZone || "";

  const timezone = getCanonicalTimezone(
    getTradingViewTimezone() ||
      reduxTimezone ||
      browserTimezone ||
      "UTC",
  );

  return {
    nickname:
      typeof nickname === "string" ? nickname : "",

    first_name:
      typeof first_name === "string" ? first_name : "",

    last_name:
      typeof last_name === "string" ? last_name : "",

    email: typeof email === "string" ? email : "",

    phone: typeof phone === "string" ? phone : "",

    /*
     * Для порожньої дати використовуємо null,
     * щоб dayjs не створював поточну дату.
     */
    date_birth:
      typeof date_birth === "string" && date_birth.trim()
        ? date_birth
        : null,

    /*
     * Для CountrySelect порожнє значення — це "".
     */
    country:
      typeof country === "string" ? country : "",

    ondato_status: ondato_status ?? 1,
    is_user_verified: Boolean(is_user_verified),
    kyc_submission: kyc_submission ?? null,
    id,
    display_id,
    reduxAvatarUrl: avatar_url,
    locale,
    timezone,
  };
};
